(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bl-about-trust"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-bl-about-slider]').forEach((slider) => {
        if (slider.dataset.initialized === 'true') return;
        slider.dataset.initialized = 'true';
        const slides = Array.from(slider.querySelectorAll('[data-slide-index]'));
        const dots = Array.from(slider.querySelectorAll('[data-slider-dot]'));
        const previous = slider.querySelector('[data-slider-prev]');
        const next = slider.querySelector('[data-slider-next]');
        const pause = slider.querySelector('[data-slider-pause]');
        const pauseText = slider.querySelector('[data-pause-text]');
        const pauseIcon = slider.querySelector('[data-pause-icon]');
        const status = slider.querySelector('[data-slider-status]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const interval = Number(slider.dataset.interval) || 5000;
        let active = 0;
        let timer;
        let paused = reducedMotion;
        const show = (index, announce = false) => {
          active = (index + slides.length) % slides.length;
          slides.forEach((slide, i) => {
            const isActive = i === active;
            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', String(!isActive));
          });
          dots.forEach((dot, i) => {
            const isActive = i === active;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-selected', String(isActive));
            dot.setAttribute('tabindex', isActive ? '0' : '-1');
          });
          if (announce && status) status.textContent = `${active + 1} / ${slides.length}`;
        };
        const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
        const start = () => {
          stop();
          if (!paused && slides.length > 1) timer = window.setInterval(() => show(active + 1), interval);
        };
        const updatePause = () => {
          if (!pause) return;
          const label = paused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
          pause.setAttribute('aria-label', label);
          if (pauseText) pauseText.textContent = label;
          if (pauseIcon) pauseIcon.textContent = paused ? '▶' : 'Ⅱ';
        };
        if (slides.length < 2) {
          slider.querySelector('.bl-about__slider-controls')?.setAttribute('hidden', '');
          return;
        }
        previous?.addEventListener('click', () => { show(active - 1, true); start(); });
        next?.addEventListener('click', () => { show(active + 1, true); start(); });
        dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.sliderDot), true); start(); }));
        pause?.addEventListener('click', () => { paused = !paused; updatePause(); start(); });
        slider.addEventListener('mouseenter', stop);
        slider.addEventListener('mouseleave', start);
        slider.addEventListener('focusin', stop);
        slider.addEventListener('focusout', start);
        slider.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1, true); }
          if (event.key === 'ArrowRight') { event.preventDefault(); show(active + 1, true); }
        });
        updatePause();
        start();
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-service-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-service-nav]').forEach((nav) => {
        if (nav.dataset.initialized === 'true') return;
        nav.dataset.initialized = 'true';
        const links = Array.from(nav.querySelectorAll('[data-service-nav-link]'));
        const targets = links.map((link) => document.querySelector(link.getAttribute('href'))).filter(Boolean);
        if (!targets.length || !('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id));
          });
        }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });
        targets.forEach((target) => observer.observe(target));
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-tracking-tool"]) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-bl-track]').forEach((track) => {
        if (track.dataset.initialized === 'true') return;
        track.dataset.initialized = 'true';
        const form = track.querySelector('[data-track-form]');
        const results = track.querySelector('[data-track-results]');
        const table = track.querySelector('[data-track-table]');
        const rows = track.querySelector('[data-track-rows]');
        const empty = track.querySelector('[data-track-empty]');
        const loader = track.querySelector('[data-track-loader]');
        const error = track.querySelector('[data-track-error]');
        const submit = track.querySelector('[data-track-submit]');
        const showMessage = (message) => {
          error.textContent = message;
          error.focus();
        };
        const setLoading = (loading) => {
          results.setAttribute('aria-busy', String(loading));
          loader.hidden = !loading;
          submit.disabled = loading;
          if (loading) {
            empty.hidden = true;
            table.hidden = true;
          }
        };
        const showResultMessage = (message) => {
          rows.textContent = '';
          table.hidden = true;
          empty.hidden = false;
          empty.textContent = message;
        };
        const addTracking = (tracking) => {
          const row = document.createElement('tr');
          const courier = document.createElement('td');
          const number = document.createElement('td');
          const action = document.createElement('td');
          courier.textContent = String(tracking[0] || '');
          number.textContent = String(tracking[1] || '');
          const link = document.createElement('a');
          try {
            const url = new URL(String(tracking[2] || ''), window.location.origin);
            if (url.protocol !== 'http:' && url.protocol !== 'https:') throw new Error();
            link.href = url.href;
            link.target = '_blank';
            link.rel = 'noopener';
            link.textContent = 'Track';
            action.append(link);
          } catch {
            action.textContent = 'Details pending';
          }
          row.append(courier, number, action);
          rows.append(row);
        };
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          error.textContent = '';
          const orderNumber = form.elements.order_number.value.trim();
          const email = form.elements.email.value.trim();
          if (!orderNumber) {
            showMessage('Please enter your order number.');
            form.elements.order_number.focus();
            return;
          }
          if (!email || !form.elements.email.validity.valid) {
            showMessage('Please enter the email address used for your order.');
            form.elements.email.focus();
            return;
          }
          setLoading(true);
          try {
            const params = new URLSearchParams({ order_number: orderNumber, email, channel: 'betalife' });
            const response = await fetch('https://tbsandbox.co.nz/api/index/shopifyTrackingInfo?' + params.toString(), { method: 'GET' });
            if (!response.ok) throw new Error();
            const data = await response.json();
            rows.textContent = '';
            if (Array.isArray(data) && data.length) {
              data.forEach(addTracking);
              empty.hidden = true;
              table.hidden = false;
            } else if (data === 400) {
              showResultMessage('Please check that your order number is correct.');
            } else if (data === 401) {
              showResultMessage('Please check that the email address matches your order.');
            } else {
              showResultMessage('Your tracking details are being prepared. Please check again soon.');
            }
          } catch {
            showResultMessage('We’re having trouble checking tracking right now. Please try again shortly or contact our team.');
          } finally {
            setLoading(false);
          }
        });
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-template"]) return;
  try {
    
  $(function(){
    $('.tab-title').click(function(){
      $(this).toggleClass('active');
      $(this).children('.la-plus').toggle();
      $(this).siblings('.tab-content').toggle();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
